// extracted by mini-css-extract-plugin
module.exports = {"list":"Tournaments_list___rQA-"};